import { useEffect } from "react";
import {
  Breadcrumb,
  Button,
  Container,
  Content,
  Header,
  IconButton,
} from "rsuite";
import { buildBreadcrumbs } from "./sidenavbar-buildBreadcrumbs";

interface IBreadcrumDisplay {
  activePage: string;
}
export const BreadcrumDisplay: React.FC<IBreadcrumDisplay> = ({ activePage }) => {
  const breadCrumList = buildBreadcrumbs(activePage);
  useEffect(() => {}, []);

  return (
    <div className="ms-2">
    <Breadcrumb
    separator={<span style={{ margin: "0 1px", color: '#0070f3' }}>➤</span>}>
      {breadCrumList?.map((crumb, index) => (
        <Breadcrumb.Item
          key={index}
          active={index === breadCrumList?.length - 1}
          style={{
            fontWeight: index === breadCrumList?.length - 1 ? "bold" : "normal",
            fontSize: "16px",
            color: index === breadCrumList?.length - 1 ? "#1a73e8" : "#555",
          }}
        >
          {crumb}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
    </div>
  );
};
